if (window.Element && !Element.prototype.attachEvent) {
    Element.prototype.attachEvent = function (event, func) {
        this.addEventListener(event.split('on')[1], func);
    };

    Element.prototype.detachEvent = function (event, func) {
        this.removeEventListener(event.split('on')[1], func);
    };
}
